/**
 * @module vuexモジュール
 */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import requestApi from './modules/requestApi';
import appInfo from './modules/appInfo';

Vue.use(Vuex);

export default new Vuex.Store({
  // Vuexで管理する状態を定義
  state: {
    agreementSelectDialogSelectItem: {},
    customerNumber: '', // お客様番号
    districtSplitNumber: '', // 地区番号
    deviceID: '', // デバイスID
    oneDistrictCustomerNumber: '', // 地区1件の時のお客様番号
    oneDistrictSplitNumber: '', // 地区1件の時の地区番号
    oneCameraCustomerNumber: '', // カメラ1件の時のお客様番号
    oneCameraDeviceID: '', // カメラ1件の時のデバイスID
    currentDisplayType: 1, // 現在の画面タイプ 1: 対象地区 2: カメラ
    thanks: {
      // thanks画面
      fromPageInfo: { page: 0 },
      displayType: 0,
    },
    sorryType: 0, // sorry画面
    displayDistrictTotal: 0, // 対象地区情報件数
    displayType: 0,
    cameraTotal: 0, // カメラ情報件数
    securityAreaId: '', // 警備エリアID
    csrfToken: '',
    answer: '', // FE-CU05,06で使用
    isLoggedIn: false,
    displayDistrictUserType: 0,
    cameraUserType: 0,
    origin: {
      userId: '',
      name: '',
      userType: 1,
    },
    modifiedForNewPassword: '',
    firstAidInfoId: 0, // 救急情報の編集対象 0:新規追加 1:配列の1番目 2:配列の2番目
    fromType: 0, // beforeRouteEnterで設定 0：トップ, 1: 対象地区, 2: カメラ
    emergencyContactNumber: 0, // 緊急連絡先設定画面のタブ番号
    serviceCheck: false, // 利用規約チェックフラグ
    privacyPolicyCheck: false, // プライバシーポリシーチェックフラグ
    historyTabNumber: 0, // 通知履歴タブ番号
    targetAreaDetailTabNumber: 0,
    cameraTabNumber: 0,
    cameraDetailTabNumber: 0,
    notificationHistoryTabNumber: 0,
    districtOneCountFlag: false, // 表示地区が1件かどうかのフラグ
    disableHomeSecurityActive: false, // 権限・表示地区情報一覧ありの場合、ホームセキュリティボタン表示
    isTopHomeSecurityActive: false, // API_0701 ホームセキュリティボタン表示
    cameraOneCountFlag: false, // カメラが1件かどうかのフラグ
    disableCamera: false, // 権限・カメラ情報一覧ありの場合、カメラボタン表示
    isTopCameraActive: false, // API_0701 カメラボタン表示
    toggle: false, // mobile navbar
    backButtonFlag: false, // 戻るボタンフラグ
    subUserId: '', //user.mail
    gettingInFlag: false, // FECU12警報確認画面 侵入フラグ
    takeoverTokenFlg: false,
  },

  // stateの値を取得する処理を定義（引数のstateは上で宣言した状態管理オブジェクト）
  getters: {
    csrfToken(state) {
      return state.csrfToken;
    },
    isLoggedIn(state) {
      return state.isLoggedIn;
    },
  },

  // stateの値を変更する処理を定義（引数のstateは上で宣言した状態管理オブジェクト（非同期処理に対応していない））
  mutations: {
    setCameraTotal(state, payload) {
      state.cameraTotal = payload.cameraTotal;
    },
    setThanksType(state, payload) {
      state.thanks.fromPageInfo = payload.fromPageInfo;
      state.thanks.displayType = payload.displayType;
    },
    setSorryType(state, payload) {
      state.sorryType = payload.sorryType;
    },
    setCustomerNumber(state, payload) {
      state.customerNumber = payload.customerNumber;
    },
    setDistrictSplitNumber(state, payload) {
      state.districtSplitNumber = payload.districtSplitNumber;
    },
    setDeviceID(state, payload) {
      state.deviceID = payload.deviceID;
    },
    setOneDistrictCustomerNumber(state, payload) {
      state.oneDistrictCustomerNumber = payload.oneDistrictCustomerNumber;
    },
    setOneDistrictSplitNumber(state, payload) {
      state.oneDistrictSplitNumber = payload.oneDistrictSplitNumber;
    },
    setOneCameraCustomerNumber(state, payload) {
      state.oneCameraCustomerNumber = payload.oneCameraCustomerNumber;
    },
    setOneCameraDeviceID(state, payload) {
      state.oneCameraDeviceID = payload.oneCameraDeviceID;
    },
    setCsrfToken(state, payload) {
      state.csrfToken = payload.csrfToken;
    },
    setDisplayDistrictTotal(state, payload) {
      state.displayDistrictTotal = payload.displayDistrictTotal;
    },
    setAnswer(state, payload) {
      state.answer = payload.answer;
    },
    setIsLoggedIn(state, payload) {
      state.isLoggedIn = payload.isLoggedIn;
    },
    setDisplayDistrictUserType(state, payload) {
      state.displayDistrictUserType = payload.displayDistrictUserType;
    },
    setCameraUserType(state, payload) {
      state.cameraUserType = payload.cameraUserType;
    },
    // onyl should be used in FE-CU37,40
    setOrigin(state, payload) {
      state.origin = payload.origin;
    },
    setModifiedForNewPassword(state, payload) {
      state.modifiedForNewPassword = payload.modifiedForNewPassword;
    },
    setFromType(state, payload) {
      state.fromType = payload.fromType;
    },
    setHistoryTabNumber(state, payload) {
      state.historyTabNumber = payload.historyTabNumber;
    },
    setTargetAreaDetailTabNumber(state, { targetAreaDetailTabNumber }) {
      state.targetAreaDetailTabNumber = targetAreaDetailTabNumber;
    },
    setCameraTabNumber(state, { cameraTabNumber }) {
      state.cameraTabNumber = cameraTabNumber;
    },
    setCameraDetailTabNumber(state, { cameraDetailTabNumber }) {
      state.cameraDetailTabNumber = cameraDetailTabNumber;
    },
    setNotificationHistoryTabNumber(state, { notificationHistoryTabNumber }) {
      state.notificationHistoryTabNumber = notificationHistoryTabNumber;
    },
    setToggle(state, payload) {
      state.toggle = payload;
    },
    setBackButtonFlag(state, payload) {
      state.backButtonFlag = payload.backButtonFlag;
    },
    setSubUserId(state, payload) {
      state.subUserId = payload.subUserId;
    },
    setGettingInFlag(state, payload) {
      state.gettingInFlag = payload.gettingInFlag;
    },
    setTakeoverTokenFlg(state, payload) {
      state.takeoverTokenFlg = payload.takeoverTokenFlg;
    },
  },

  // mutationを呼び出す処理を定義（非同期も対応している）
  actions: {},

  // vuexで状態管理するファイルを外部ファイル化している場合に使用する
  modules: {
    requestApi,
    appInfo, // 利用環境を状態管理
  },

  plugins: [
    createPersistedState({
      // ストレージのキーを指定。デフォルトではvuex
      key: 'vuex',

      // 管理対象のステートを指定。pathsを書かない時は`modules`に書いたモジュールに含まれるステート全て。`[]`の時はどれも保存されない
      paths: [
        'customerNumber',
        'districtSplitNumber',
        'currentDisplayType',
        'displayType',
        'securityAreaId',
        'csrfToken',
        'answer',
        'deviceID',
        'displayDistrictUserType',
        'cameraUserType',
        'origin',
        'modifiedForNewPassword',
        'firstAidInfoId',
        'fromType',
        'emergencyContactNumber',
        'serviceCheck',
        'privacyPolicyCheck',
        'historyTabNumber',
        'targetAreaDetailTabNumber',
        'cameraTabNumber',
        'cameraDetailTabNumber',
        'notificationHistoryTabNumber',
        'districtOneCountFlag',
        'disableHomeSecurityActive',
        'isTopHomeSecurityActive',
        'cameraOneCountFlag',
        'disableCamera',
        'isTopCameraActive',
        'toggle',
        'backButtonFlag',
        'oneDistrictCustomerNumber',
        'oneDistrictSplitNumber',
        'oneCameraCustomerNumber',
        'oneCameraDeviceID',
        'cameraTotal',
        'subUserId',
        'gettingInFlag',
        'takeoverTokenFlg',
        'appInfo.nativeAppInfo.nativeVersion',
      ],

      // ストレージの種類を指定する。デフォルトではローカルストレージ
      storage: window.sessionStorage,
    }),
  ],
});
